import { render, staticRenderFns } from "./theme-list.vue?vue&type=template&id=edef57fe&"
import script from "./theme-list.vue?vue&type=script&lang=js&"
export * from "./theme-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports